import { awBridgeApi } from './Base';

interface listMapping {
  cusip: string;
  listTag: string;
  listValue: string;
}

interface ListMappingRequest {
  listTag: string;
  listValue: string;
  order?: number;
}

export interface ListMappingResponse {
  listMappings: listMapping[];
}

export async function getCusipBySleeveID(tag: string, value: string, pkg: string, date: string) {
  const path = `/v1/security/list-mapping`;

  const result = await awBridgeApi.get<ListMappingResponse>(path, {
    params: { tag, value, pkg, date },
  });
  return result;
}

export async function getCusipsBySleeveIDList(tag: string, valueList: string[], date: string, pkg: string) {
  const path = `/v1/security/listMappings:bulkGet?&date=${date}`;

  const params: ListMappingRequest[] = valueList.map((value) => ({ listTag: tag, listValue: value }));

  const result = await awBridgeApi.post<ListMappingResponse>(path, params, { params: { pkg } });
  return result;
}
